import { cva } from 'class-variance-authority'

export const rootVariants = cva(
  'flex h-4 w-4 pointer-events-none flex-shrink-0 items-center justify-center rounded-md outline-none transition-colors duration-100',
  {
    variants: {
      isChecked: {
        true: 'bg-blue-500',
        false:
          'ring-2 ring-inset ring-gray-200 group-hover/item:ring-gray-400 dark:ring-gray-700 dark:group-hover/item:ring-gray-600',
      },
      isDisabled: {
        true: 'opacity-50',
        false: '',
      },
    },
    compoundVariants: [
      {
        isDisabled: true,
        isChecked: false,
        className:
          'ring-gray-200 group-hover/item:ring-gray-200 dark:ring-gray-700 dark:group-hover/item:ring-gray-700',
      },
    ],
  },
)
